import styled from '@emotion/styled';
import { IconButton, Box, Switch, Card, Button, Chip, Typography, Paper } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';

export const UserWrapper = styled(Box)({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: '20px',
    fontFamily: "'sf-pro-display-regular', sans-serif"
});

export const AddButton = styled(Button)({
    backgroundColor: '#F5E0B5',
    color: '#333333',
    '&:hover': {
        backgroundColor: '#F5E0B5',
        color: '#333333'
    }
});

export const PositiveText = styled(Typography)({
    color: '#1a237e',
    fontWeight: 600,
    backgroundColor: 'rgba(26, 35, 126, 0.08)',
    borderRadius: '6px',
    padding: '4px 12px',
    fontSize: '0.875rem',
    letterSpacing: '0.5px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
        backgroundColor: 'rgba(26, 35, 126, 0.12)',
        transform: 'translateY(-1px)',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    }
});

export const NegativeText = styled(Typography)({
    color: '#d32f2f',
    fontWeight: 600,
    backgroundColor: 'rgba(211, 47, 47, 0.08)',
    borderRadius: '6px',
    padding: '4px 12px',
    fontSize: '0.875rem',
    letterSpacing: '0.5px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
        backgroundColor: 'rgba(211, 47, 47, 0.12)',
        transform: 'translateY(-1px)',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    }
});

export const TooltipButton = styled(IconButton)({
    borderRadius: 3,
    border: '0px !important',
    outline: '0px !important',
    color: '#333333',
    '&:hover': {
        border: '0px !important',
        outline: '0px !important',
        color: '#333333'
    }
});

export const ImageUploadButton = styled(Button)({
    padding: '35px 15px',
    backgroundColor: 'transparent',
    borderRadius: '10px',
    color: '#333333',
    border: '2px solid #F5E0B5'
});

export const ImageUploadContainer = styled(Box)({
    position: 'relative',
    display: 'inline-block',
    backgroundColor: '#dcdde1',
    borderRadius: '10px',
    textAlign: 'center'
});

export const StyledFileInput = styled.input`
    position: absolute;
    width: 100%;
    height: 100%;
    cursor: pointer;
    top: 0;
    right: 0;
    opacity: 0;
`;

export const StyledChip = styled(Chip)`
    color: '#333333';
    border: 1px solid ${(props) => (props.isEmailVerified ? 'yellow' : 'black')};
`;

export const TableWrapper = styled(Box)({
    padding: '20px 15px'
});

export const StyledSwitch = styled(Switch)`
    .MuiSwitch-switchBase.Mui-checked {
        color: #fdd588;
    }
    .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track {
        background-color: #fdd588;
    }
    .MuiSwitch-switchBase {
        color: #333333;
    }
`;

export const GlobalInputLabel = styled(InputLabel)(() => ({
    fontSize: 14,
    lineHeight: '17px',
    letterSpacing: 0,
    marginBottom: 8,
    color: '#333333'
}));

export const GlobalInputLabelRequired = styled.span`
    font-size: 16px;
    color: #d32f2f;
`;

export const CardUITextLable = styled(Card)({
    margin: 'auto',
    boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.1)',
    padding: '20px',
    marginBottom: '20px'
});

export const CardUIImage = styled(Card)({
    margin: 'auto',
    maxHeight: '140px',
    boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.1)',
    marginBottom: '20px',
    display: 'flex',
    padding: '15px 20px'
});

export const CardUIView = styled(Card)({
    margin: 'auto',
    height: '200px',
    boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.1)',
    display: 'flex',
    padding: '20px',
    flexDirection: 'column'
});

export const StatusContainer = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px',
    borderRadius: '8px',
    backgroundColor: '#f5f5f5',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
        backgroundColor: '#eeeeee'
    }
});

export const StatusIndicator = styled(Box)(({ status }) => ({
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    backgroundColor: status === 'active' ? '#1a237e' : '#d32f2f',
    boxShadow: `0 0 8px ${
        status === 'active' ? 'rgba(26, 35, 126, 0.4)' : 'rgba(211, 47, 47, 0.4)'
    }`,
    animation: status === 'active' ? 'pulse 2s infinite' : 'none',
    '@keyframes pulse': {
        '0%': {
            boxShadow: '0 0 0 0 rgba(26, 35, 126, 0.4)'
        },
        '70%': {
            boxShadow: '0 0 0 6px rgba(26, 35, 126, 0)'
        },
        '100%': {
            boxShadow: '0 0 0 0 rgba(26, 35, 126, 0)'
        }
    }
}));

export const UserCard = styled(Paper)({
    padding: '16px',
    borderRadius: '12px',
    backgroundColor: '#ffffff',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    transition: 'all 0.3s ease-in-out',
    '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 4px 12px rgba(0,0,0,0.12)'
    }
});

export const UserInfo = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    padding: '12px',
    backgroundColor: 'rgba(26, 35, 126, 0.02)',
    borderRadius: '8px',
    border: '1px solid rgba(26, 35, 126, 0.08)'
});

export const UserLabel = styled(Typography)({
    color: '#1a237e',
    fontWeight: 500,
    fontSize: '0.875rem',
    letterSpacing: '0.5px',
    textTransform: 'uppercase'
});

export const UserValue = styled(Typography)({
    color: '#424242',
    fontWeight: 400,
    fontSize: '1rem',
    letterSpacing: '0.25px'
});
